const TARIFFS_URL_BY_LOCALE: Record<string, string> = {
    ru: 'https://smetter.ru/tariffs',
    en: 'https://smetter.com/tariffs',
};

export const getTariffsUrl = (locale: string) => {
    const language = locale.toLowerCase().split(/[-_]/)[0];

    return TARIFFS_URL_BY_LOCALE[language] ?? TARIFFS_URL_BY_LOCALE.en;
};
